module.exports = __webpack_public_path__ + "static/img/20040B_1_2_3_4_5_C_20230522_fit.9070c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20040B_1_2_3_4_5_C_20230522_fit.png
// module id = x0gI
// module chunks = 0